module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_0@2x.cbcab57d.png";